import { render } from "./Operario.vue?vue&type=template&id=33fe34d0"
import script from "./Operario.vue?vue&type=script&lang=js"
export * from "./Operario.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__